import { OptimizelyDecideOption } from '@optimizely/react-sdk';
var activateOrDecide = function activateOrDecide(client, key, id) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$disableDecisionE = _ref.disableDecisionEvent,
    disableDecisionEvent = _ref$disableDecisionE === void 0 ? false : _ref$disableDecisionE;
  var variation = disableDecisionEvent ? client.getVariation(key, id) : client.activate(key, id);
  if (!variation) {
    var decideOptions = disableDecisionEvent ? [OptimizelyDecideOption.DISABLE_DECISION_EVENT] : undefined;
    variation = client.decide(key, decideOptions, id).variationKey;
  }
  return variation;
};
export default activateOrDecide;